module.exports = __webpack_public_path__ + "img/offer3.4dca0995.png";